// Piloto da aba Instagram: a equipe sempre ve; cliente so nos perfis liberados em
// VITE_INSTAGRAM_CUSTOMER_PROFILES (ids separados por virgula). Existe para o login
// do revisor da Meta na Analise do app; esvaziar a variavel quando ela terminar.
export const perfisLiberadosParaCliente = (valor: string | undefined): string[] =>
  (valor ?? "")
    .split(",")
    .map((id) => id.trim().toLowerCase())
    .filter(Boolean);

export const podeVerAbaInstagram = (opcoes: {
  habilitada: boolean;
  usuarioInterno: boolean;
  podeEditar: boolean;
  perfilId?: string | number | null;
  liberados: string[];
}): boolean => {
  if (!opcoes.habilitada) return false;
  if (opcoes.usuarioInterno) return true;
  if (!opcoes.podeEditar || opcoes.perfilId == null) return false;
  return opcoes.liberados.includes(String(opcoes.perfilId).toLowerCase());
};
